import { LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import LoadingCont from 'components/Audition/LoadingCont';
import {
  AuditionItemsContainer,
  Content,
  ContentItemContainer,
  Heading,
  MainContainer,
  ScrollCont,
} from 'pages/PastSelfTapes/PastSelfTapes.styles';
import PastSelfTapesItem from 'pages/PastSelfTapes/PastSelfTapesItem/PastSelfTapesItem';
import React from 'react';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';

interface Props {
  data: IAuditionSchedulesAttributes[];
  loading: boolean;
  pending: IAuditionSchedulesAttributes[];
  isPendingLoading: boolean;
}

const UpcomingSelftapes: React.FC<Props> = ({ data, loading, isPendingLoading, pending }) => {
  const isBothHaveData = data.length > 0 && pending.length > 0;

  return loading || isPendingLoading ? (
    <LoadingCont />
  ) : (
    <MainContainer style={{ marginTop: 20 }}>
      <div>
        {data.length ? (
          <React.Fragment>
            <Heading>Confirmed ST Request</Heading>
            <ScrollCont style={{ height: isBothHaveData ? 'calc(50vh - 160px)' : 'calc(100vh - 250px)' }}>
              <AuditionItemsContainer>
                {data.map((a) => (
                  <PastSelfTapesItem confirmed data={a} status={a.status} />
                ))}
              </AuditionItemsContainer>
            </ScrollCont>
          </React.Fragment>
        ) : (
          <React.Fragment />
        )}
        {pending.length ? (
          <React.Fragment>
            <Heading style={{ marginTop: 20 }}>Pending ST Request</Heading>
            <ScrollCont style={{ height: isBothHaveData ? 'calc(50vh - 160px)' : 'calc(100vh - 220px)' }}>
              <AuditionItemsContainer>
                {pending.map((a) => (
                  <PastSelfTapesItem confirmed data={a} status={a.status} />
                ))}
              </AuditionItemsContainer>
            </ScrollCont>
          </React.Fragment>
        ) : (
          <React.Fragment />
        )}
      </div>
    </MainContainer>
  );
};

export default UpcomingSelftapes;
